import { render, staticRenderFns } from "./OrderSummaryCategoryProduct.vue?vue&type=template&id=0c4caf91&"
import script from "./OrderSummaryCategoryProduct.vue?vue&type=script&lang=js&"
export * from "./OrderSummaryCategoryProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports